// extracted by mini-css-extract-plugin
export default {"avatar":"_6uHt2c","withBorder":"gKpQnM","filter":"Ra3uen"};